import { first } from 'rxjs/operators';
import { Subscription, Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgClass, NgTemplateOutlet, AsyncPipe } from '@angular/common';
import { FormBuilder, FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';

import { LoginFormModel, UserModel } from '../../core/models/auths';

import { AuthService } from '../../core/services/auths';
import { NotificationService } from '../../shared/services';

@Component({
   selector: 'app-login',
   templateUrl: './login.component.html',
   styleUrl: './login.component.scss',
   standalone: true,
   imports: [ReactiveFormsModule, NgClass, NgTemplateOutlet, AsyncPipe],
})
export class LoginComponent implements OnInit, OnDestroy {
   returnUrl: string = '';
   hasError: boolean = false;
   isLoading$: Observable<boolean>;
   loginForm: FormGroup<LoginFormModel> = this.initForm();

   // private readonly fields
   private readonly unsubscribe: Subscription[] = [];

   constructor(private readonly fb: FormBuilder, private readonly authService: AuthService, private readonly route: ActivatedRoute, private readonly router: Router, private readonly notifir: NotificationService) {
      this.isLoading$ = this.authService.isLoading$;
   }

   ngOnInit(): void {
      // If guard supplied a returnUrl, keep it; otherwise default to dashboard
      this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    
      if (this.authService.currentAuthValue) {
        this.router.navigate(['/dashboard'], { replaceUrl: true });
      }
    }

   // convenience getter for easy access to form fields
   get f() {
      return this.loginForm.controls;
   }

   initForm() {
      return this.fb.group<LoginFormModel>({
         userName: new FormControl('',
            Validators.compose([
               Validators.required,
               Validators.minLength(3),
               Validators.maxLength(100),
            ]),
         ),
         password: new FormControl('',
            Validators.compose([
               Validators.required,
               Validators.minLength(6),
               Validators.maxLength(100),
            ]),
         ),
      });
   }

   submit(): void {
      this.authService.login({ userName: this.f.userName.value, password: this.f.password.value })
        .pipe(first())
        .subscribe(auth => {
          if (auth) {
            this.notifir.alertSuccess('You have successfully logged in!').then(() => {
              this.router.navigate(
                [this.returnUrl || '/'],
                { replaceUrl: true }
              );
            });
          } else {
            this.notifir.alertDanger('', 'Your user name or password are wrong');
          }
        });
    }
   
   ngOnDestroy() {
      this.unsubscribe.forEach((sb) => sb.unsubscribe());
   }
}
